"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogGridView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const ImageWrap = app_1.styled.div `
  width: 100%;
  aspect-ratio: 1;
`;
const StickyStack = (0, app_1.styled)(ui_1.Stack) `
  position: sticky;
  top: var(--nav-height);
  background: ${(theme) => theme.background};
  z-index: 1;
  padding: ${(theme) => theme.spacing.extraSmall};
  padding-bottom: ${(theme) => theme.spacing.large};
  justify-content: center;
  * {
    text-transform: uppercase;
  }
`;
const ContentWrap = (0, app_1.styled)(ui_1.Stack) ``;
const ItemCategory = (0, app_1.styled)(app_1.Text) `
  text-transform: uppercase;
`;
const GridWrap = (0, app_1.styled)(ui_1.Grid) `
  margin: 0 auto !important;
  text-align: left;
  @media ${app_1.notDesktop} {
    grid-template-columns: 1fr;
  }
`;
function BlogGridView({ categories, articles, onCategoryClick, }) {
    const { t } = (0, app_1.useTranslation)();
    const articlePath = (0, app_1.useContextPath)('article');
    const isMobile = (0, app_1.useIsMobile)(1024);
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(StickyStack, Object.assign({ fullWidth: true, spacing: "large" }, { children: isMobile ? ((0, jsx_runtime_1.jsxs)(ui_1.SelectInput, Object.assign({ name: "category", defaultValue: "ALL", onChange: (value) => {
                        onCategoryClick(value === 'ALL' ? null : value);
                        return value;
                    } }, { children: [(0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: "ALL" }, { children: t('label.all') })), categories.map((category) => ((0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: category.title }, { children: category.title }), category.slug)))] }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", onClick: () => onCategoryClick(null) }, { children: t('label.all') })), categories.map((category) => ((0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", onClick: () => onCategoryClick(category.title) }, { children: category.title }), category.slug)))] })) })), (0, jsx_runtime_1.jsx)(GridWrap, Object.assign({ templateColumns: "1fr 1fr 1fr", gap: "large" }, { children: articles.map((article) => ((0, jsx_runtime_1.jsx)(app_1.AssetsProvider, Object.assign({ path: `${articlePath}/${article.id}` }, { children: (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: `${articlePath}/${article.slug}` }, { children: (0, jsx_runtime_1.jsxs)(ContentWrap, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(ImageWrap, { children: (0, jsx_runtime_1.jsx)(app_1.Image, { img: article.image }) }), (0, jsx_runtime_1.jsx)(ItemCategory, Object.assign({ as: "sub-h4" }, { children: article.category.title })), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ as: "sub-h2" }, { children: article.title })), article.description ? ((0, jsx_runtime_1.jsx)(app_1.Text, { children: article.description })) : null] })) })) }), article.slug))) }))] })));
}
exports.BlogGridView = BlogGridView;
